import Checkbox from './Inputs/Checkbox.vue';
import IconCheckbox from './Inputs/IconCheckbox.vue';
import Radio from './Inputs/Radio.vue';
import FormGroupInput from './Inputs/formGroupInput.vue';
import Switch from './Switch.vue';
import Badge from './Badge';
import Progress from './Progress.vue';
import Button from './Button.vue';

import DropDown from './Dropdown.vue';
import Table from './Table.vue';

import Card from './Cards/Card.vue';
import StatsCard from './Cards/StatsCard.vue';
import Navbar from './Navbar/Navbar';
import NavbarToggleButton from './Navbar/NavbarToggleButton';

import Breadcrumb from './Breadcrumb/Breadcrumb.vue';
import BreadcrumbItem from './Breadcrumb/BreadcrumbItem.vue';
import RouteBreadCrumb from './Breadcrumb/RouteBreadcrumb.vue';
import TimeLine from './Timeline/TimeLine.vue';
import TimeLineItem from './Timeline/TimeLineItem.vue';
import TabPane from './Tabs/Tab.vue';
import Tabs from './Tabs/Tabs.vue';
import Collapse from './Collapse/Collapse.vue';
import CollapseItem from './Collapse/CollapseItem.vue';
import Modal from './Modal.vue';
import Slider from './Slider.vue';
import SimpleWizard from './Wizard/Wizard.vue';
import WizardTab from './Wizard/WizardTab.vue';
import LoadingPanel from './LoadingPanel.vue';
import AsyncWorldMap from './WorldMap/AsyncWorldMap.vue';

import Pagination from './Pagination.vue';

import SidebarPlugin from './SidebarPlugin';

import AnimatedNumber from './AnimatedNumber';

import CustomForm from './CustomForm/CustomForm.vue';
import PoolForm from './CustomForm/PoolForm.vue';
import CoordinatorsForm from './CustomForm/CoordinatorsForm.vue';
import DynamicForm from './CustomForm/DynamicForm.vue';
import PreviewForm from './CustomForm/PreviewForm.vue';
import RegisterForm from './CustomForm/RegisterForm.vue';

import IconCard from './CustomCards/IconCard.vue';
import PreviewCard from './CustomCards/PreviewCard.vue';
import NewsCard from './CustomCards/NewsCard.vue';
import NewsletterCard from './CustomCards/NewsletterCard.vue';
import ReportCard from './CustomCards/ReportCard.vue';
import TicketCard from './CustomCards/TicketCard.vue';

import NoticeCard from './CustomCards/NoticeCard.vue';
import NoticesCard from './CustomCards/NoticesCard.vue';

import TodayCard from './CustomCards/TodayCard.vue';
import RegistrationProgress from './CustomProgress/RegistrationProgress.vue';

import CurrentUser from './CurrentUser';

import PDFVuer from './PDFVuer.vue';

export {
  Checkbox,
  IconCheckbox,
  Switch,
  Badge,
  Progress,
  Pagination,
  Radio,
  FormGroupInput,
  Card,
  StatsCard,
  Table,
  DropDown,
  SidebarPlugin,
  Navbar,
  NavbarToggleButton,
  Breadcrumb,
  BreadcrumbItem,
  RouteBreadCrumb,
  TimeLine,
  TimeLineItem,
  TabPane,
  Tabs,
  Modal,
  Slider,
  SimpleWizard,
  WizardTab,
  AnimatedNumber,
  Button,
  Collapse,
  CollapseItem,
  LoadingPanel,
  AsyncWorldMap,
  //custom components
  CustomForm,
  CoordinatorsForm,
  DynamicForm,
  PreviewForm,
  RegisterForm,
  PoolForm,
  IconCard,
  PreviewCard,
  NewsCard,
  NewsletterCard,
  CurrentUser,
  NoticeCard,
  NoticesCard,
  TodayCard,
  ReportCard,
  TicketCard,
  PDFVuer,
  RegistrationProgress
};
